import React from 'react';
import { Divider, TextArea } from 'semantic-ui-react';

const SpecialInstructions = ({
  specialInstructions,
  onSpecialInstructionsChange,
  showDivider = true,
  checkoutDisabled,
}) => {
  return (
    <div className="item-cart-special-instructions">
      {showDivider && <Divider />}
      <h5>SPECIAL INSTRUCTIONS</h5>
      <TextArea
        value={specialInstructions}
        onChange={onSpecialInstructionsChange}
        disabled={checkoutDisabled}
      />
    </div>
  );
};

export default SpecialInstructions;
